import React from 'react';
import { translate } from 'react-multi-lang';
import { Table } from 'antd';
import { AllHtmlEntities } from 'html-entities';

import ContainerPagina from '../../../components/ContainerPagina';
import TitolPagina from '../../../components/TitolPagina';
import LlistaEditable from '../../../components/LlistaEditable';
import Edit from '../../../components/Formularis/perfils/admin/ProfessorsCarrecs';
import { Api, InitDades } from '../../../helpers';

const { Column } = Table;
const entities = new AllHtmlEntities();

function ProfessorsCarrecs(props) {


  const buscarDades = async () => {
    const ca = await Api.get('/professors/carrecs/existents');
    if(ca.result.success!==1){return [];}

    return ca.data.carrecs;

  }

  const marcarEliminat = async (id) => {
    const fam = await Api.myFetch('/professors/carrecs/existents/'+id, 'DELETE');
    if(fam.result.success===1){

    }
  }

  return(
    <ContainerPagina>
      <TitolPagina txt={props.t('menu.CarrecsProfessors')}/>
      <div style={{marginTop:'1rem', marginLeft:'3rem'}}>
        <LlistaEditable
          txt_creats={props.t('professors_relacions.creados')}
          txt_nou={props.t('professors_relacions.nuevo')}
          buscarDades={buscarDades}
          edit={Edit}
          delete={marcarEliminat}
          itemBuit={InitDades.professor_carrec()}>
          <Column
          title="Id"
          key="id"
          sorter={(a, b) =>  (a.id - b.id)}
          render={(text,record) => (
            <span>{record.id}</span>
          )}
          />
          <Column
          title={props.t('professors_relacions.carrec')}
          key="nom"
          render={(text,record) =>entities.decode(record.nom[props.t('idioma')])}
          />
          <Column
          title={props.t('professors_relacions.ambit')}
          key="ambit"
          render={(text,record) =>{
            const ambit = record.ambit;
            const temp = ambit.charAt(0).toUpperCase() + ambit.slice(1);
            return props.t(`menu.${temp}`)
          }}
          />
        </LlistaEditable>
      </div>
    </ContainerPagina>
  );

}

export default translate(ProfessorsCarrecs);
